import { RouteRecordRaw } from "vue-router";
import App from '../../App.vue';

export const AdminRoutes: RouteRecordRaw = {
    path: '/admin',
    redirect: "/admin/contracts",
    component: App,
    meta: {
        title: "Creative Contract Admin Portal",
        metaTags: [
            {
                name: "description",
                content: "Admin Portal",
            },
        ],
    },
    children: [
        {
            path: "contracts",
            name: "admin-comics",
            component: () => import("../../modules/admin/pages/ComicsPage.vue"),
        },
        {
            path: "contract/details/:id",
            name: "comic-details",
            component: () => import("../../modules/admin/pages/comic-review/ComicDetails.vue"),
            props: true,
        },
        {
            path: "clients",
            name: "clients",
            component: () => import("../../modules/admin/pages/ClientsPage.vue"),
        },
        {
            path: "client/details/:id",
            name: "client-details",
            component: () =>
                import("../../modules/admin/components/template-details/ClientDetails.vue"),
        },
        {
            path: "users",
            name: "users",
            component: () => import("../../modules/admin/pages/UsersPage.vue"),
        },
        {
            path: "comic-builder",
            name: "comic-builder",
            component: () => import("../../modules/admin/pages/comic-builder/ComicBuilder.vue"),
        }
    ],
};